import { Injectable } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { addDays, format } from 'date-fns';
import { FilterCodec } from '../codec/filter-codec.service';
import { CompositeFilter, isCompositePredicate, isTagPredicate, Predicate } from '../filter.type';
import { UrlService } from "@teammood/shared/util/url";
import { ActivatedRoute } from "@angular/router";

@Injectable(
  {providedIn: 'root'}
)
export class SavedFilterService {

  private encodedFilter: string;
  private dateRange: DateRange<Date> = new DateRange<Date>(addDays(new Date(), -30), new Date());

  constructor(
    private urlService: UrlService,
    private filterCodec: FilterCodec,
    private route: ActivatedRoute,
  ) { }

  getCurrentFilter() {
    return this.encodedFilter  || this.route.snapshot.params['filter'];
  }

  saveFilter(filter: CompositeFilter) {
    if (filter && filter.predicates) {
      const filterWithoutTagIds: CompositeFilter = this.omitTagIds(filter)
      this.encodedFilter = this.filterCodec.encode(filterWithoutTagIds);
    }
    this.saveParamsInUrl();
  }

  private saveParamsInUrl() {
    let queryParams = this.urlService.getQueryParams();

    const start = format(this.dateRange.start, 'dd-MM-yyyy');
    queryParams = queryParams.set('start', start);

    const end = format(this.dateRange.end, 'dd-MM-yyyy');
    queryParams = queryParams.set('end', end);

    queryParams = queryParams.set('filter', this.encodedFilter);

    this.urlService.replaceQueryParams(queryParams);
  }

  saveDateRange(dateRange: DateRange<Date>) {

    this.dateRange = dateRange;
    this.saveParamsInUrl();
  }

  getDateRange(): DateRange<Date> {
    return this.dateRange;
  }



  private omitTagIds(obj: CompositeFilter) {
    return { predicates: this.omitTagIdsFromPredicate(obj.predicates) };
  }

  private omitTagIdsFromPredicate(predicates: Predicate[]) {
    return predicates.map(predicate => {
      if (isCompositePredicate(predicate)) {
        return {
          combinator: predicate.combinator,
          predicates: this.omitTagIdsFromPredicate(predicate.predicates)
        }
      } else if (isTagPredicate(predicate)) {
        return {
          org_unit_type: predicate.org_unit_type,
          org_unit_value: predicate.org_unit_value
        }
      } else {
        return predicate
      }
    })
  }
}